'use client';

import Color from 'color';
import { useState } from 'react';
import { GiLargePaintBrush } from 'react-icons/gi';

import { Badge } from 'components/ui/badge';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from 'components/ui/form';
import { Popover, PopoverContent, PopoverTrigger } from 'components/ui/popover';

import ColorPicker from '@/components/ColorPicker';

export default function FormFieldColorPicker({
  form,
  defaultValue,
  fieldName,
  labelText,
  onColorPicked,
  presetColors,
  onPopupOpenOrClose = (_x) => {},
}) {
  const [fieldColor, setFieldColor] = useState(defaultValue);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <div className="w-fit">
          <FormLabel className="flex items-center space-x-1 text-xs sm:text-base">
            <GiLargePaintBrush />
            <span>{labelText}</span>
          </FormLabel>

          <Badge
            className="hover:cursor-pointer"
            style={{ backgroundColor: fieldColor }}
          >
            <span
              className={
                Color(fieldColor).luminosity() > 0.5
                  ? 'text-black'
                  : 'text-white'
              }
            >
              {defaultValue}
            </span>
          </Badge>
        </div>
      </PopoverTrigger>

      <PopoverContent
        className="flex w-auto flex-col space-y-2 p-2"
        onOpenAutoFocus={(_e) => onPopupOpenOrClose(true)}
        onEscapeKeyDown={(_e) => onPopupOpenOrClose(false)}
        onInteractOutside={(_e) => onPopupOpenOrClose(false)}
      >
        <FormField
          control={form.control}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          name={fieldName}
          defaultValue={defaultValue}
          render={({ field }) => (
            <FormItem className="">
              <FormLabel className="flex items-center space-x-1 text-xs sm:text-base">
                <GiLargePaintBrush />
                <span>Color</span>
              </FormLabel>

              <FormControl className="col-span-2">
                <ColorPicker
                  setIsEditingColor={null}
                  className="justify-self-right"
                  color={fieldColor}
                  showBackButton={false}
                  setColor={(color) => {
                    field.onChange(color);
                    setFieldColor(color);
                  }}
                  onColorChange={(color) => {
                    field.onChange(color);
                    setFieldColor(color);
                  }}
                  onColorPicked={(color) => {
                    onColorPicked(color);
                  }}
                  presetColors={presetColors}
                />
              </FormControl>
            </FormItem>
          )}
        />
      </PopoverContent>
    </Popover>
  );
}
